import React, { useEffect, useState } from 'react';
import { useLocaleContext } from '../../../context/LocaleContext';
import { CButton, CDropDown, CSearch, CInputSuggestions } from '../../UI';

import './style.scss';

const FiltersOrganization = ({organizationsList, onFilter, maxWidth = 240}) => {
    const $locale = useLocaleContext();
    const [suggestionName, setSuggestionName] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [isFilterActive, setFilterActive] = useState(false);
    const [isSuggestionFit, setSuggestionFit] = useState('max-content');

    useEffect(() => {
        updateTriggerStyles();
    }, [suggestionName]);

    function handleSelectValue(value) {
        setSuggestionName(value);
        setFilterActive(false);
        onFilter(value);
        setInputValue(value);
    }

    function updateTriggerStyles() {
        const triggerButton = document.querySelector('.schedule-filters-organization-suggestion');
        const triggerButtonRect = triggerButton.getBoundingClientRect();

        setSuggestionFit(triggerButtonRect.width < maxWidth);
    }

    function handleResetValue() {
        setSuggestionName('');
        onFilter('');
        setInputValue('');
    }

    function handleSetMemberSuggestions(value) {
        return organizationsList.filter((organization) => {
            return organization.toLowerCase().includes(value.toLowerCase());
        });
    }

    return (
        <div
            className="schedule-filters-organization"
            style={{ maxWidth }}
        >
            {
                !!suggestionName &&
                <CButton
                    blank
                    icon="close"
                    onClick={handleResetValue}
                />
            }
            <CDropDown
                trigger={<CButton
                    blank
                    label={suggestionName || $locale.get('label.organization.select')}
                    iconPosition="right"
                    icon="arrow_down"
                    className="schedule-filters-organization-suggestion"
                    style={{width: isSuggestionFit ? 'max-content' : '180px'}}
                    onClick={() => setFilterActive(true)}
                />}
                maxWidth={300}
                isClosed={!isFilterActive}
            >
                <CInputSuggestions
                    $locale={$locale}
                    suggestionsList={organizationsList}
                    hasInputValue={!!inputValue}
                    apiCallback={handleSetMemberSuggestions}
                    onSelect={handleSelectValue}
                >
                    <CSearch
                        value={suggestionName}
                        isActive={isFilterActive}
                        hasButton={false}
                        placeholder={$locale.get('label.search.organization')}
                        onSearch={setInputValue}
                    />
                </CInputSuggestions>
            </CDropDown>
        </div>
    );
};

export default FiltersOrganization;
